import { render, staticRenderFns } from "./TableHeaderSorting.vue?vue&type=template&id=400b9bb6&scoped=true&"
import script from "./TableHeaderSorting.vue?vue&type=script&lang=ts&"
export * from "./TableHeaderSorting.vue?vue&type=script&lang=ts&"
import style0 from "./TableHeaderSorting.vue?vue&type=style&index=0&id=400b9bb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b9bb6",
  null
  
)

export default component.exports